function isValuePresent(value: string | number) {
  return Boolean(value);
}

export default isValuePresent;